import { hash } from '@ember/helper';
import { service } from '@ember/service';

import CpPanel from 'ember-collapsible-panel/components/cp-panel/component';
import { not } from 'ember-truth-helpers';
import { trackedFunction } from 'reactiveweb/function';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsAudioplayerComponent extends Component {
  // Services
  @service data;

  // Getter and setter
  get audioplayerShopCategories() {
    return this.loadShopCategories.value ?? [];
  }

  // Functions
  loadShopCategories = trackedFunction(this, async () => {
    return await this.data.getCategories({ 'filter[type]': 'SHOP' });
  });

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='headline' />
            <fieldset.field @property='subHeadline' />

            <fieldset.field
              @filters={{hash assetFolderId='2'}}
              @property='cover'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>

            <fieldset.field
              @property='artist'
              @type='belongs-to'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>
        </div>

        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='settings' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            <fieldset.field
              @property='audioplayerShops'
              @type='has-many-join'
              @hasManyForeignModelName='audioplayer-shop'
              @on={{hash
                openNewRecord=this.newRecord
                removeRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              as |audioplayerShop|
            >
              <CpPanel @open={{audioplayerShop.isNew}} as |panel|>
                <panel.toggle>
                  {{audioplayerShop.categoryId.name}}
                </panel.toggle>

                <panel.body>
                  <Form
                    @model={{audioplayerShop}}
                    @parentModel={{form.model}}
                    as |subform|
                  >
                    <subform.field
                      @property='categoryId'
                      @type='select-record'
                      @disabled={{not audioplayerShop.isNew}}
                      @options={{this.audioplayerShopCategories}}
                    />

                    <subform.field @property='url' />
                    <subform.field
                      @property='partnerType'
                      @type='select-value'
                      @options={{this.data.partnerTypes}}
                    />
                  </Form>
                </panel.body>
              </CpPanel>
            </fieldset.field>
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>

      <div class='o-layout'>
        <div class='o-layout__item u-1/1'>
          <form.fieldset @titleKey='trackList' as |fieldset|>
            <fieldset.field
              @label={{false}}
              @on={{hash
                openNewRecord=this.newRecord
                removeRecord=this.deleteRelation
                openRecord=false
                openRecordList=false
              }}
              @filters={{hash artist=form.model.artist.screenname}}
              @property='tracks'
              @type='has-many'
              as |record|
            >
              <Form @model={{record}} as |subform|>
                <div class='o-layout'>
                  <div class='o-layout__item u-1/5@tablet'>
                    <subform.field @property='name' />
                  </div>
                  <div class='o-layout__item u-1/5@tablet'>
                    <subform.field @property='artist' />
                  </div>
                  <div class='o-layout__item u-1/5@tablet'>
                    <subform.field @property='url' />
                  </div>
                  <div class='o-layout__item u-1/5@tablet'>
                    <subform.field
                      @filters={{hash assetFolderId='11'}}
                      @property='audioFile'
                      @options={{hash allowedFolder='101'}}
                      @type='belongs-to'
                    />
                  </div>
                  <div class='o-layout__item u-1/5@tablet'>
                    <subform.field @property='availableFrom' @type='date' />
                  </div>
                </div>
              </Form>
            </fieldset.field>
          </form.fieldset>
        </div>
      </div>
    </Form>
  </template>
}
